/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { ArtworkDto } from '../models/ArtworkDto';
import { CloneArtworkRequest } from '../models/CloneArtworkRequest';
import { ContactArtistRequest } from '../models/ContactArtistRequest';
import { EditionDto } from '../models/EditionDto';
import { FavoriteRequest } from '../models/FavoriteRequest';
import { NewArtworkRequest } from '../models/NewArtworkRequest';
import { PaginatedArtworkDto } from '../models/PaginatedArtworkDto';
import { RequestDto } from '../models/RequestDto';
import { TransferArtworkRequest } from '../models/TransferArtworkRequest';
import { UpdateArtworkRequest } from '../models/UpdateArtworkRequest';
import { ApiError, catchGenericError } from '../core/ApiError';
import { request as __request } from '../core/request';
import { OpenAPI } from '../core/OpenAPI';

export class ArtworkService {

    /**
     * Create an artwork
     * @param requestBody
     * @result ArtworkDto
     * @throws ApiError
     */
    public static async artworkControllerNewArtwork(
        requestBody: NewArtworkRequest,
    ): Promise<ArtworkDto> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get Artwork details
     * @param id
     * @result ArtworkDto
     * @throws ApiError
     */
    public static async artworkControllerGetArtworkDetails(
        id: number,
    ): Promise<ArtworkDto> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork`,
            query: {
                'id': id,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get artwork page
     * @param page
     * @param pageSize
     * @param artist
     * @param rarity
     * @param search
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerGetArtworkPage(
        page: number,
        pageSize: number,
        artist?: number,
        rarity?: string,
        search?: string,
    ): Promise<Array<any>> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/page`,
            query: {
                'page': page,
                'pageSize': pageSize,
                'artist': artist,
                'rarity': rarity,
                'search': search,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get Artwork owners
     * @param id
     * @result number
     * @throws ApiError
     */
    public static async artworkControllerGetArtworkOwners(
        id: number,
    ): Promise<Array<number>> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/owners`,
            query: {
                'id': id,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get collector pieces
     * @param page
     * @param pageSize
     * @param rarity
     * @param search
     * @param artworkId
     * @result PaginatedArtworkDto
     * @throws ApiError
     */
    public static async artworkControllerGetCollectorPieces(
        page: number,
        pageSize: number,
        rarity?: string,
        search?: string,
        artworkId?: string,
    ): Promise<PaginatedArtworkDto> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/owned-pieces`,
            query: {
                'page': page,
                'pageSize': pageSize,
                'rarity': rarity,
                'search': search,
                'artworkId': artworkId,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get artwork owned editions
     * @param artworkId
     * @result EditionDto
     * @throws ApiError
     */
    public static async artworkControllerGetArtworkEditions(
        artworkId: number,
    ): Promise<Array<EditionDto>> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/${artworkId}/editions`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Update artwork
     * @param requestBody
     * @result ArtworkDto
     * @throws ApiError
     */
    public static async artworkControllerUpdateArtwork(
        requestBody: UpdateArtworkRequest,
    ): Promise<ArtworkDto> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/update`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Transfer artwork
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerTransferArtwork(
        requestBody: TransferArtworkRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/transfer`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Clone artwork
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerCloneArtwork(
        requestBody: CloneArtworkRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/clone`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Request artwork
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerRequestArtwork(): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/request`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get Artwork requests
     * @result RequestDto
     * @throws ApiError
     */
    public static async artworkControllerGetRequests(): Promise<Array<RequestDto>> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/requests`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Accept request
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerAcceptRequest(): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/accept-request`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Reject request
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerRejectRequest(): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/reject-request`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Contact Artist
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerContactArtist(
        requestBody: ContactArtistRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/contact-artist`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Favorite art
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerFavorite(
        requestBody: FavoriteRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/favorite`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Favorite art
     * @param requestBody
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerUnfavorite(
        requestBody: FavoriteRequest,
    ): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/artwork/unfavorite`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Check if artwork is favorite
     * @param artworkId
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerGetFavorite(
        artworkId: number,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/${artworkId}/favorite`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get artwork creation cost
     * @result any
     * @throws ApiError
     */
    public static async artworkControllerGetArtworkCreationCost(): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/artwork/cost`,
        });

        catchGenericError(result);

        return result.body;
    }

}


// WEBPACK FOOTER //
// ./src/services/openapi/generated/services/ArtworkService.ts